export default __webpack_public_path__ + "static/media/imgDocumentacionTecnica.cc2ee421.png";